import { PERMISSIONS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(PERMISSIONS_ENDPOINT);
export default instance;
